module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container AppointmentsCalendar"
  }, [_c('FullCalendar', {
    attrs: {
      "defaultView": "dayGridMonth",
      "locale": _vm.locale,
      "firstDay": _vm.firstDay,
      "header": _vm.calendarHeader,
      "plugins": _vm.calendarPlugins,
      "events": _vm.concat,
      "height": _vm.height
    },
    on: {
      "datesRender": _vm.datesRender,
      "eventClick": _vm.handleDateClick
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f514c80e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Appointments/AppointmentsCalendar.vue
// module id = 1487
// module chunks = 0